<template>
    <div class="container remove-padding-margin" id="listlayanansnap">
        <div id="loadingPageImportSnap">
            <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
            <center>
                <h4 style="margin-top:15px"><span class="count" id="dataCOunter">0</span>%</h4>
                <h5>Proses impor..</h5>
            </center>
        </div>
	    <div id="dataSnap">
	        <div class="fixed-judul fixed-top">
	            <div class="row justify-content-center align-items-center set-row showPageDefault">
	                <div class="col-md-1 col-sm-1 col-1 remove-padding">
	                    <img @click="back" src="../../assets/gambar/back-blue.svg" alt="">
	                </div>
	                <div class="col-md-10 col-sm-10 col-10 text-center remove-padding">
	                    <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">Daftar Layanan Self Service</h6>
	                </div>
	                <div class="col-md-1 col-sm-1 col-1 remove-padding">
	                    <img class="imageSearch" src="../../assets/icons/search.svg" @click="showsearch" alt="" id="iconsearchsnap">
	                </div>
	            </div>
		        <div class="showPageDefault">
			        <div class="bg-yellow p-x-20 p-y-8 d-flex align-items-center border-bottom" v-if="snaplayanan.filter(v => v.jenis === 'Dropoff').length > 0">
				        <img src="@/assets/icons/alert-circle-yellow.svg" alt="" class="m-r-12">
				        <div class="d-block">
					        <div class="f-regular f-12 f-c-midgrey">
						        Terdapat layanan jenis Drop Off di halaman ini, mohon untuk membuat ulang di halaman Layanan Reguler.
					        </div>
				        </div>
			        </div>
			    </div>
	            <div class="row justify-content-center align-items-center set-row showPageSearch">
	                <div class="col-md-9 col-sm-9 col-9 remove-padding">
	                    <input class="inputSearch" id="input_search_Snap" type="text" v-on:keyup="searchsnap"
	                           v-model="searchKey"
	                           placeholder="Cari..">
	                </div>
	                <div class="col-md-3 col-sm-3 col-3 remove-padding">
	                    <img class="imageSearch" v-on:click="closesearch" src="../../assets/img/x2.svg" alt="">
	                </div>
	            </div>
	        </div>
	        <main class="add-padding-default bg-gray">
            <div class="flex-100 showPageSearch">
                <div class="flex-1" v-if="snapsearch.length >= 0">
                    <div class="Search-BOX mar-top-60 mar-bottom-16" id="textTopsnap"></div>
<!--                    <div class="">-->
                        <div class="row set-card" v-for="ss in snapsearch" :key="ss.idsnap">
                            <div class="col-md-10 col-sm-10 col-10 text-left remove-padding">
                                <div class="nomore"><b v-html="searchHighlight(ss.nama, searchKey)"></b></div>
                            </div>
                            <div class="col-md-2 col-sm-2 col-2 text-right remove-padding dropdown"
                                 id="dropdownMenuLink" :data-toggle="validateAccess('selfServices.update') && 'dropdown'" aria-haspopup="true"
                                 aria-expanded="false">
                                <img src="../../assets/icons/more-horizontal-grey.svg" alt="">
                                <div class="dropdown-menu garis-deposit" aria-labelledby="dropdownMenuLink">
                                    <a class="dropdown-item icon-1" href="#" @click="edits(ss.idsnap)" v-if="validateAccess('selfServices.update')"><span
                                            class="mar-right-10"><i class="far fa-edit color-206CF"></i></span>Ubah</a>
                                    <a class="dropdown-item icon-2" href="#" @click="showmodaldelsearchsnap(ss)" v-if="validateAccess('selfServices.delete')"><span
                                            class="mar-right-10"><img src="../../assets/icons/trash-2.svg"></span>Hapus</a>
                                </div>
                            </div>
	                        <div class="col-md-12 col-sm-12 col-12 text-left remove-padding">
								<div class="f-13 f-c-midgrey m-d-4" v-if="ss.jam_tertentu_aktif != 0"><img style="width: 16px" src="../../assets/icons/alert-info-tertentu.svg" alt=""> Aktif Jam {{ss.jam_tertentu_awal}} -  {{ss.jam_tertentu_akhir}}</div>
		                        <div class="f-13 f-c-midgrey m-d-4" v-if="ss.idjenis_mesin != 3"><img src="../../assets/icons/clock.svg" alt=""> {{ss.durasi_penyelesaian_jam}} Jam  {{ss.durasi_penyelesaian_Menit}} Menit</div>
		                        <div class="d-flex-between-center m-d-4">
			                        <div class="f-regular f-13 f-c-midgrey"><img src="@/assets/icons/washer.svg" alt=""> Mesin Snapbridge {{ss.tipe}}</div>
			                        <div v-if="ss.jenis === 'Dropoff'" class="info-snap f-12 f-c-yellow f-regular bg-yellow">
				                        Dropoff
			                        </div>
		                        </div>
		                        <div class="d-flex-between-center">
			                        <div class="f-semi f-14 f-c-blue"><img src="../../assets/icons/tag1.svg" alt=""> Rp. {{ss.harga}}</div>
			                        <div class="info-snap f-12 f-c-midgrey f-regular bg-grey"> Snapbridge</div>
		                        </div>
	                        </div>
                        </div>
<!--                    </div>-->
                </div>
	            <div class="loadmoreSpinner" id="loadingSpinnerSnapSearch" style="display: none">
		            <center>
			            <div class="sp sp-circle"></div>
		            </center>
	            </div>
            </div>

            <div class="flex-100 showPageDefault">
                <div class="flex-1 pad-top-50" v-if="snaplayanan.length===0">
                    <div class="image text-alignC">
                        <img class="img-fluid" src="../../assets/icons/Hanger.svg" alt="">
                        <h5 class="text-center">Belum ada layanan yang terdaftar</h5>
                        <h6 class="text-center">Silahkan klik tombol + untuk menambahkan</h6>
                    </div>
<!--                    <div class="pointer offanimation dropdown">-->
<!--                        <span class="btn add-menu" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img src="../../assets/img/plus-1.svg" alt=""></span>-->
<!--                        <div class="dropdown-menu garis" aria-labelledby="dropdownMenuLink" style="top: -12px;">-->
<!--                            <a class="dropdown-item" href="#" @click="tambahsnap"><img src="../../assets/icons/plus1.svg">Tambahkan Layanan Baru</a>-->
<!--                            <a class="dropdown-item" href="#" data-toggle="modal" data-target="#modalsnap"><img src="../../assets/icons/upload.svg">Impor Data Layanan</a>-->
<!--                            <a class="dropdown-item" href="#" @click="exportLayanansnap"><img src="../../assets/icons/upload(1).svg">Expor Data Layanan</a>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
                <div class="flex-1 pad-top-50" v-else>
                    <div class="card-2">
                        <div>Total {{snaplayanan.length}} Layanan</div>
                        <FilterSorting :jenisFilter="'snap'" @filter="filter" />
                        <br>
                        <div class="row set-card" v-for="S in snaplayanan" :key="S.idsnap">
                            <div class="col-md-10 col-sm-10 col-10 text-left remove-padding">
                                <div class="nomore"><b>{{S.nama}}</b></div>
                            </div>
                            <div class="col-md-2 col-sm-2 col-2 text-right remove-padding dropdown"
                                 :id="'dropdownMenuLinklist'+S.id" :data-toggle="validateAccess('selfServices.update') && 'dropdown'" aria-haspopup="true" aria-expanded="false">
                                <img src="../../assets/icons/more-horizontal-grey.svg" alt="">
                                <div class="dropdown-menu garis-snap" aria-labelledby="dropdownMenuLinklist">
                                    <a class="dropdown-item icon-1" href="#" @click="edit(S.idsnap)" v-if="validateAccess('selfServices.update')"><span
                                            class="mar-right-10"><i class="far fa-edit color-206CF"></i></span>Ubah</a>
                                    <a class="dropdown-item icon-2" href="#" @click="showmodaldelsnapp(S)" v-if="validateAccess('selfServices.delete')"><span
                                            class="mar-right-10"><img src="../../assets/icons/trash-2.svg"></span>Hapus</a>
                                </div>
                            </div>
	                        <div class="col-md-12 col-sm-12 col-12 text-left remove-padding">
								<div class="f-13 f-c-midgrey m-d-4" v-if="S.jam_tertentu_aktif != 0"><img style="width: 16px" src="../../assets/icons/alert-info-tertentu.svg" alt=""> Aktif Jam {{S.jam_tertentu_awal}} -  {{S.jam_tertentu_akhir}}</div>
								<div class="f-13 f-c-midgrey m-d-4" v-if="S.idjenis_mesin != 3"><img src="../../assets/icons/clock.svg" alt=""> {{S.durasi_penyelesaian_jam}} Jam  {{S.durasi_penyelesaian_Menit}} Menit</div>
		                        <div class="d-flex-between-center m-d-4">
			                        <div class="f-regular f-13 f-c-midgrey"><img src="@/assets/icons/washer.svg" alt=""> Mesin Snapbridge {{S.tipe}}</div>
			                        <div v-if="S.jenis === 'Dropoff'" class="info-snap f-12 f-c-yellow f-regular bg-yellow">
				                        Dropoff
			                        </div>
		                        </div>
		                        <div class="d-flex-between-center">
			                        <div class="f-semi f-14 f-c-blue"><img src="../../assets/icons/tag1.svg" alt=""> Rp. {{S.harga}}</div>
			                        <div class="info-snap f-12 f-c-midgrey f-regular bg-grey" v-if="S.tipe !== 'Reguler (Tanpa Mesin Snapbridge)'"> Snapbridge</div>
			                        <div class="info-snap f-12 f-c-midgrey f-regular bg-grey" v-else> Tanpa Mesin</div>
		                        </div>
	                        </div>
                        </div>
	                    <div class="loadmoreSpinner" id="loadingSpinnerSnap" style="display: none">
		                    <center>
			                    <div class="sp sp-circle"></div>
		                    </center>
	                    </div>
                    </div>
                </div>
                <div class="modal fade" id="modalsnap" role="dialog">
                    <div class="modal-dialog modal-lg  bani-modal">
                        <div class="modal-content">
                            <div class="modal-header">
                                <div class="nav-btn kiri"></div>
                                <h5 class="navbar-title text-center">Impor Data Layanan snap</h5>
                                <div class="nav-btn kanan tutup">
                                    <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                </div>
                            </div>
                            <div class="modal-body">
                                <div class="font-16 remove-padding-margin desciption-txt-modal">File yang diupload harus berupa file excel dengan format penulisan sesuai dengan contoh berikut:</div>
                                <!--                                    <div class="div-impor mar-top-bot-15 color-206CF"><img class="" src="../../assets/icons/download.svg" alt=""> Template Data Layanan Snap</div>-->
<!--                                <a :href="url_import_template" target="_blank">-->
                                    <div class="div-impor mar-top-bot-15 color-206CF" @click="cekconnection">
                                        <img class="" src="../../assets/icons/download.svg" alt=""> Template Data Layanan
                                    </div>
<!--                                </a>-->
                                <div class="mar-bottom-16 desciption-txt-modal">Jika sudah sesuai dengan template, silahkan upload file melalui kolom dibawah ini.</div>
                                <div class="line-patah mar-bottom-20">
                                    <div class="atribute" id="imagePreview">
                                      <label for="importLayananSnap">
                                          <img src="../../assets/icons/file-plus.svg" alt="" style="max-width: 70px" id="logo">
                                      <div>Klik untuk upload...</div>
                                      </label>
                                      <input type='file' id="importLayananSnap" ref="file" v-on:change="importdatasnap"
                                             accept=".xlsx"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
	        <div class="flying-button-wrapper w-limit context-menu">
		        <div class="flying-inside dropup">
			        <a class="flying-button" data-toggle="dropdown" data-display="static"></a>
			        <div class="dropdown-menu">
				        <a class="dropdown-item" @click="tambahsnap" v-if="validateAccess('selfServices.create')">
					        <div class="icon-prefix" style="background-image: url('../../assets/icons/plus1.svg')">
					        </div>Tambahkan Layanan Baru
				        </a>
				        <a class="dropdown-item" data-toggle="modal" data-target="#modalsnap" v-if="validateAccess('selfServices.create')">
					        <div class="icon-prefix" style="background-image: url('../../assets/icons/upload.svg')">
					        </div>Impor Data Layanan
				        </a>
				        <a class="dropdown-item" href="#" @click="exportLayanansnap">
					        <div class="icon-prefix"
					             style="background-image: url('../../assets/icons/upload(1).svg')"></div>Ekspor Data Layanan
				        </a>
			        </div>
		        </div>
	        </div>

		        <div class="modal fade" id="deletemodalsnap" role="dialog">
			        <div class="modal-dialog modal-lg  bani-modal">
				        <div class="modal-content">
					        <div class="modal-header">
						        <div class="nav-btn kiri"></div>
						        <div class="navbar-title text-center">Hapus Layanan Snap</div>
						        <div class="nav-btn kanan tutup">
							        <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
						        </div>
					        </div>
					        <div class="modal-body">
						        <p class="font-14 remove-padding-margin">Data yang dihapus tidak dapat dikembalikan.Apakah anda yakin ingin menghapus Layanan <b>{{namasnap}}</b>?</p>
					        </div>
					        <div class="modal-footer">
						        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
						                @click="Delete">Hapus
						        </button>
					        </div>
				        </div>
			        </div>
		        </div>
		        <div class="modal fade" id="deletemodalsearchsnap" role="dialog">
			        <div class="modal-dialog modal-lg  bani-modal">
				        <div class="modal-content">
					        <div class="modal-header">
						        <div class="nav-btn kiri"></div>
						        <div class="navbar-title text-center">Hapus Layanan Snap</div>
						        <div class="nav-btn kanan tutup">
							        <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
						        </div>
					        </div>
					        <div class="modal-body">
						        <p class="font-14 remove-padding-margin">Data yang dihapus tidak dapat dikembalikan.Apakah anda yakin ingin menghapus Layanan <b>{{namasnap}}</b>?</p>
					        </div>
					        <div class="modal-footer">
						        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
						                @click="Delete">Hapus
						        </button>
					        </div>
				        </div>
			        </div>
		        </div>
        </main>
	    </div>
    </div>
</template>

<script>
	import FilterSorting from "@/component-items/FilterSorting";

    export default {
        name: "SnapService",
        props:['setidoutletsetservice'],
	    components: {FilterSorting},
        data(){
            return{
                myVarLoopingFunc: '',
                snapsearch:[],
                snaplayanan:[],
                outlet:{},
                searchKey: '',
                namasnap:'',
                idsnap:'',
                isClicked : false,
                fileImport: '',
                progressloadingimpor: 0,
                url_import_template: this.$template_import_layanan_snap_url,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },

	            snapPagination: {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "nama",
		            orderBy: "ASC",
	            },
	            snapSearchPagination: {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "nama",
		            orderBy: "ASC",
		            key: ""
	            },
	            listSnapcleanCalled: false,
            }
        },
        mounted() {

            this.idoutlet = this.$route.params.idoutlet
            // this.idsnap = this.$route.params.idsnap
            // this.detailoutlet()
            $(".showPageSearch").hide()

	        $('body').on('DOMSubtreeModified', '#listlayanansnap', () => {
		        if (!this.listSnapcleanCalled) {
			        this.listSnapcleanCalled = true
			        this.scroll()
		        }
	        });
        },
        methods:{
	        scroll() {
		        window.onscroll = () => {
			        if ($('#loadingSpinnerSnap').is(":hidden")) {
				        if ($(".showPageDefault").is(":visible")) {
					        if (this.snapPagination.pageNumber <= Math.ceil(this.snapPagination.length / this.snapPagination.limit)) {
						        if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
							        this.snapPagination.offset = (this.snapPagination.pageNumber * this.snapPagination.limit);
							        this.listsnap();
							        $('#loadingSpinnerSnap').show()
						        }
					        }
				        }
			        }

			        if ($('#loadingSpinnerSnapSearch').is(":hidden")) {
				        if ($(".showPageSearch").is(":visible")) {
					        if (this.snapSearchPagination.pageNumber <= Math.ceil(this.snapSearchPagination.length / this.snapSearchPagination.limit)) {
						        if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
							        this.snapSearchPagination.offset = (this.snapSearchPagination.pageNumber * this.snapSearchPagination.limit);
							        this.searchsnap()
							        $('#loadingSpinnerSnapSearch').show()
						        }
					        }
				        }
			        }
		        }
	        },
            back(){
	            this.listSnapcleanCalled = false
	            this.snapPagination = {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "nama",
		            orderBy: "ASC",
	            }
	            this.snapSearchPagination = {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "nama",
		            orderBy: "ASC",
		            key: ""
	            }
                this.$emit('isdetailsetservicesnap')
            },

            tambahsnap(){
                this.$emit('gocreateservicesnap')
				this.smartTrackingClick("add_layanan_selfservice",{"idoutlet":this.idoutlet});

			},

            edit(idsnap){
                this.$emit('gotoedit',idsnap)
            },

            edits(idsnap){
                this.$emit('gotoedit',idsnap)
                this.closesearch()
            },

            showmodaldelsnapp(S) {
                this.idsnap = S.idsnap
                this.namasnap=S.nama
                $('#deletemodalsnap').modal('show')
            },
            showmodaldelsearchsnap(ss) {
                this.idsnap = ss.idsnap
                this.namasnap=ss.nama
                $('#deletemodalsearchsnap').modal('show')
            },

            async cekconnection(){
                $('#loadingPage').addClass('overlayLoading');
                this.isClicked = true
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/cek_koneksi',this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            window.open(this.url_import_template, '_blank');
                            this.flutterDownload(this.url_import_template)
                            $('#loadingPage').removeClass('overlayLoading');
                            this.isClicked = false
                        } else {
                            $('#loadingPage').removeClass('overlayLoading');
                            this.isClicked = false
	                        this.$toast.error(response.data.msg)
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#impormodal').modal('hide')
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
            async exportLayanansnap() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/snap/export_layanan_snap?idoutlet=' + this.setidoutletsetservice, this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            var filenameStorage = response.data.data.filename
                            var linkStorage = response.data.data.link_file_storage
                            window.open(linkStorage, "_blank");
                            this.flutterDownload(linkStorage)
                            this.deleteStorage(filenameStorage);
                        } else {
                        	this.$toast.error(response.data.msg)
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async importdatasnap() {
                $('#loadingPageImportSnap').addClass('overlayLoading');
                $('#loadingPageImportSnap').addClass('show-import');
                $("#dataSnap").hide();

                this.fileImport = this.$refs.file.files[0];
                try {
                    const updatedata = new FormData()
                    updatedata.append('fileExcel', this.fileImport)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/snap/import_layanan_snap?idoutlet=' + this.setidoutletsetservice, updatedata, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': 'Bearer ' + localStorage.getItem('token')
                        }
                    })
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            $("#modalsnap").modal('hide')
                            this.trackImportdata()
                            this.myVarLoopingFunc = setInterval(() => {
                                this.trackImportdata()
                            }, 5000);
                        } else {
                            $('#loadingPageImportSnap').removeClass('overlayLoading');
                            $('#loadingPageImportSnap').removeClass('show-import');
	                        $("#dataSnap").show();
                            this.$toast.error("Nama file atau extensi file yang anda unggah salah!")
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
                    $('#loadingPageImportSnap').removeClass('overlayLoading');
                    $('#loadingPageImportSnap').removeClass('show-import');
	                $("#dataSnap").show();
                    $('#impormodal').modal('hide')
                }
            },


            async trackImportdata() {
                this.fileImport = this.$refs.file.files[0];
                $("#file").val("")
                try {
                    const updatedata = new FormData()
                    updatedata.append('fileExcel', this.fileImport)
                    const response = await this.$axios.get(this.$baseurl + '/masterData/snap/tracking_import_layanan_snap?idoutlet=' + this.setidoutletsetservice, this.requestHeaders)
                    this.fileImport = ''
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            if (response.data.data.status_progress === '0') {
                                var length = response.data.data.lenght_data
                                var progress = response.data.data.progress_looping
                                var getPercen = (progress / length) * 100;
                                var oldData = $("#dataCOunter").text()
                                $("#dataCOunter").text(getPercen)
                                // this.counter(oldData)
                                // $("#dataCOunter").text(oldData)
                            } else if (response.data.data.status_progress === '1') {
                                clearInterval(this.myVarLoopingFunc);
                                // clearInterval(this.myVarLoopingFunc);
                                this.listsnap()
                                var length = response.data.data.lenght_data
                                var progress = response.data.data.progress_looping
                                var getPercen = (progress / length) * 100;
                                var oldData = $("#dataCOunter").text()
                                $("#dataCOunter").text(getPercen)
                                // this.counter(oldData)
                                // $("#dataCOunter").text(oldData)
                                // $("#dataCOunter").text(0)

                                $('#loadingPageImportSnap').removeClass('overlayLoading');
                                $('#loadingPageImportSnap').removeClass('show-import');
	                            $("#dataSnap").show();
	                            this.$toast.success(response.data.data.msg_progress)
                            } else if (response.data.data.status_progress === '2') {
                                $('#loadingPageImportSnap').removeClass('overlayLoading');
                                $('#loadingPageImportSnap').removeClass('show-import');
	                            $("#dataSnap").show();
                                clearInterval(this.myVarLoopingFunc);
                                this.listsnap()
                                $("#dataCOunter").text(0)
	                            this.$toast.error(response.data.data.msg_progress)
                            }
                        } else {
                            $("#dataCOunter").text(0)
                            if (response.data.data.status_progress === '3') {
                                $('#loadingPageImportSnap').removeClass('overlayLoading');
                                $('#loadingPageImportSnap').removeClass('show-import');
	                            $("#dataSnap").show();
                                clearInterval(this.myVarLoopingFunc);
                                this.$toast.error(response.data.data.msg_progress)
                            }
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                clearInterval(this.myVarLoopingFunc);
                    $('#loadingPageImportSnap').removeClass('overlayLoading');
                    $('#loadingPageImportSnap').removeClass('show-import');
	                $("#dataSnap").show();
                }
            },

            counter(args) {
                $(".count").prop('Counter', 0).animate({
                    Counter: $(".count").text()
                }, {
                    duration: 5000,
                    easing: 'swing',
                    step: function (now) {
                        var data = Math.ceil(now)
                        if (now >= args) {
                            $(".count").text(data);
                        }
                        if (data == 100) {
                            setTimeout(() => {
                                $('#loadingPageImportSnap').removeClass('overlayLoading');
                                $('#loadingPageImportSnap').removeClass('show-import');
	                            $("#dataSnap").show();
                            }, 4000)

                        }
                    }
                });
            },

            async deleteStorage(filenameStorage) {
                try {
                    var delexport = new FormData
                    delexport.append('filename', filenameStorage)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/snap/delete_after_export_layanan_snap?idoutlet=' + this.setidoutletsetservice, delexport,this.requestHeaders)
                } catch (e) {
                	this.$catch_error_response(e)
                }
            },
            async detailoutlet(){
                this.isClicked=true
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_outlet_meta?idoutlet=' + this.setidoutletsetservice, this.requestHeaders)
                    this.outlet = response.data.data[0]
                    this.isClicked=false
                    $('#loadingPage').removeClass('overlayLoading');
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClicked = false;
                }
            },

            newrupiahlistsnap(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^.\d]/g, "").toString(),
                    split = number_string.split("."),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            async listsnap(){
	        	if (this.snapPagination.offset === 0) {
					this.smartTrackingView("list_layanan_selfservice",{"idoutlet":this.idoutlet});

					this.snaplayanan=[];
			        $('#loadingPage').show();
			        $('#loadingPage').addClass('overlayLoading');
		        }
                var sort_get;
                var order_get;
                try {
                    sort_get = this.snapPagination.sortBy;
                    order_get = this.snapPagination.orderBy;
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_list_layanan_snap?idoutlet=' + this.setidoutletsetservice + '&order_by=' + order_get + '&sort_by=' + sort_get + '&limit=' + this.snapPagination.limit + '&offset=' + this.snapPagination.offset,this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide();
                            this.convertSeconds()
                            var datasnap = response.data.data;
                            this.snapPagination.length += datasnap.length
                            if (datasnap.length > 0) {
                                $("#iconsearchsnap").show()
                            } else {
                            	if (this.snapPagination.offset > 0) {
		                            $("#iconsearchsnap").show()
	                            } else {
		                            $("#iconsearchsnap").hide()
	                            }
                            }
	                        this.snapPagination.pageNumber++
                            for (var i = 0; i < datasnap.length; i++) {
                                var jenis_layanan
                                if (datasnap[i].tipe == 1){
                                    jenis_layanan = "Self Service"
                                }else if(datasnap[i].tipe == 2){
                                    jenis_layanan = "Dropoff"
                                }else{
                                    jenis_layanan = ""
                                }
                                var jenis_mesin
                                if(datasnap[i].jenis == 1){
                                    jenis_mesin = "Pencucian"
                                }else if(datasnap[i].jenis == 2){
                                    jenis_mesin = "Pengeringan"
                                }else {
                                    jenis_mesin = "Reguler (Tanpa Mesin Snapbridge)"
                                }
                                var nominalsnap = datasnap[i].harga;
                                var toRpsnap = this.newrupiahlistsnap(nominalsnap.toString());
                                this.snaplayanan.push({
                                    nama: datasnap[i].nama,
                                    harga: toRpsnap,
									jam_tertentu_aktif:datasnap[i].jam_tertentu_aktif,
									jam_tertentu_awal:datasnap[i].jam_tertentu_awal,
									jam_tertentu_akhir:datasnap[i].jam_tertentu_akhir,
									idsnap:datasnap[i].id,
                                    durasi_penyelesaian_jam: this.convertSeconds(datasnap[i].durasi),
                                    durasi_penyelesaian_Menit: this.sisaJam(datasnap[i].durasi),
                                    jenis: jenis_layanan,
                                    tipe: jenis_mesin,
                                    idjenis_mesin: datasnap[i].jenis,
                                })
                            }

                        }
                    }
	                $('#loadingSpinnerSnap').hide()
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingSpinnerSnap').hide()
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClicked = false;
                }
            },
            convertSeconds(seconds) {
                var hours, minutes, total_hours, total_minutes, total_seconds;

                total_seconds = parseInt(Math.floor(seconds / 1));
                total_minutes = parseInt(Math.floor(total_seconds / 60));
                total_hours = parseInt(Math.floor(total_minutes / 60));


                seconds = parseInt(total_seconds % 60);
                minutes = parseInt(total_minutes % 60);
                hours = parseInt(total_hours % 24);

                return hours
            },
            sisaJam(seconds) {
                var days, hours, sisa_jam, total_hours, total_minutes, total_seconds;

                total_seconds = parseInt(Math.floor(seconds / 1));
                total_minutes = parseInt(Math.floor(total_seconds / 60));
                total_hours = parseInt(Math.floor(total_minutes / 60));
                days = parseInt(Math.floor(total_hours / 24));
                sisa_jam = parseInt(Math.floor(total_minutes % 60));
                return sisa_jam
            },

            async Delete(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                    try {
                        const delsnap = new FormData
                        const response = await this.$axios.post(this.$baseurl + '/masterData/snap/delete_layanan_snap?idlayanansnap=' + this.idsnap,delsnap, this.requestHeaders)
                        if(response.data.status===true){
	                        await this.searchsnap()
	                        $('#loadingPage').removeClass('overlayLoading');
	                        $('#loadingPage').hide();
	                        this.listsnap()
	                        this.$toast.success(response.data.msg)
                        }else{
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            this.$toast.error(response.data.msg)
                        }

                    }catch (e) {
                    	this.$catch_error_response(e)
	                    $('#loadingPage').hide();
	                    $('#loadingPage').removeClass('overlayLoading');
                    }
                },

            async sortingLayanan(key) {
                $("#cardWorkshop").hide();
                $("#spinnerWorkshop").prop("style", "display:inline-block");
                switch (key) {
                    case "asc":
                        $('#dropdownMenuButton2').text("Urut Dari A - Z ")
                        this.getsortingLayanan(1)
                        break;
                    case "desc":
                        $('#dropdownMenuButton2').text("Urut Dari Z - A ")
                        this.getsortingLayanan(2)
                        break;
                    case "terbaru":
                        $('#dropdownMenuButton2').text("Urut Dari Terbaru ")
                        this.getsortingLayanan(3)
                        break;
                    case "terlama":
                        $('#dropdownMenuButton2').text("Urut Dari Terlama ")
                        this.getsortingLayanan(4)
                        break;
                    default:
                        $('#dropdownMenuButton2').text("Urutkan ")
                }
            },
            async getsortingLayanan(datasortingsnap) {
                var sort_by
                var order_by
                //var key = jika ada search nanti dipake
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    if (datasortingsnap === 1) {
                        sort_by = "nama";
                        order_by = "ASC";
                    } else if (datasortingsnap === 2) {
                        sort_by = "nama";
                        order_by = "DESC";
                    } else if (datasortingsnap === 3) {
                        sort_by = "created_at";
                        order_by = "DESC";
                    } else if (datasortingsnap === 4) {
                        sort_by = "created_at";
                        order_by = "ASC";
                    } else {
                        return
                    }
                    // var idowner = localStorage.getItem('idowner');
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_list_layanan_snap?idoutlet=' + this.setidoutletsetservice + '&order_by=' + order_by + '&sort_by=' + sort_by, this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.snaplayanan=[]
                            this.convertSeconds()
                            var data = response.data.data
                            for (var i = 0; i < data.length; i++) {
                                var jenis_layanan
                                if (data[i].tipe == 1) {
                                    jenis_layanan = "Self Service"
                                } else if (data[i].tipe == 2) {
                                    jenis_layanan = "Dropoff"
                                } else {
                                    jenis_layanan = ""
                                }
                                var jenis_mesin
                                if (data[i].jenis == 1) {
                                    jenis_mesin = "Pencucian"
                                } else if (data[i].jenis == 2) {
                                    jenis_mesin = "Pengeringan"
                                } else {
                                    jenis_mesin = ""
                                }
                                this.snaplayanan.push({
                                    nama: data[i].nama,
                                    harga: data[i].harga,
                                    idsnap: data[i].id,
									jam_tertentu_aktif:data[i].jam_tertentu_aktif,
									jam_tertentu_awal:data[i].jam_tertentu_awal,
									jam_tertentu_akhir:data[i].jam_tertentu_akhir,
									durasi_penyelesaian_jam: this.convertSeconds(data[i].durasi),
                                    durasi_penyelesaian_Menit: this.sisaJam(data[i].durasi),
                                    jenis: jenis_layanan,
                                    tipe: jenis_mesin,

                                })
                                $('#loadingPage').hide();
                                $('#loadingPage').removeClass('overlayLoading');
                            }
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
            showsearch() {
                $(".showPageSearch").show()
                $(".showPageSearch").addClass("animated slideInDown")
                $("#textTopsnap").text("Minimal 2 karakter")
                $(".showPageDefault").hide();
                $("#input_search_Snap").focus();
            },
            closesearch() {
                $(".showPageSearch").removeClass("animated slideInDown")
                $(".showPageSearch").hide()
                $(".showPageDefault").show();
                this.snapsearch = "";
                this.searchKey = "";
                $("#textTopsnap").text("Minimal 2 karakter")

	            this.snapSearchPagination = {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "created_at",
		            orderBy: "DESC",
		            key: ""
	            }
            },
            searchsnap() {
                $("#textTopsnap").text("Minimal 2 karakter")
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    $(".spinner").prop("style", "display:inline-block");
                    this.SearchFunc();
                }, 500);
            },
            async SearchFunc() {
	            var key = this.searchKey;
	        	if (this.snapSearchPagination.offset === 0 || this.snapSearchPagination.key !== key) {
			        this.snapsearch=[];
			        $("#textTopsnap").text("Sedang mencari...");
			        $('#loadingPage').show();
			        $('#loadingPage').addClass('overlayLoading');
			        this.snapSearchPagination = {
				        limit: 20,
				        offset:0,
				        length: 0,
				        pageNumber: 0,
				        sortBy: "created_at",
				        orderBy: "DESC",
				        key: key
			        }
		        }
                if (key.length >= 2) {
                    try {
                        const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_list_layanan_snap?idoutlet=' + this.setidoutletsetservice + '&key=' + key + '&limit=' + this.snapSearchPagination.limit + '&offset=' + this.snapSearchPagination.offset, this.requestHeaders)
                        if (response.status === 200) {
                            if (response.data.status === true) {
                                $('#loadingPage').hide();
                                $('#loadingPage').removeClass('overlayLoading');
                                this.snapSearchPagination.length += response.data.data.length
                                if (response.data.data.length > 0) {
                                    $("#textTopsnap").text("Ditemukan " + response.data.data.length + " layanan dengan kata '" + key + "'");
                                    this.convertSeconds()
                                    var data = response.data.data
                                    for (var i = 0; i < data.length; i++) {
                                        var jenis_layanan
                                        if (data[i].tipe == 1) {
                                            jenis_layanan = "Self Service"
                                        } else if (data[i].tipe == 2) {
                                            jenis_layanan = "Dropoff"
                                        } else {
                                            jenis_layanan = ""
                                        }
                                        var jenis_mesin
                                        if (data[i].jenis == 1) {
                                            jenis_mesin = "Pencucian"
                                        } else if (data[i].jenis == 2) {
                                            jenis_mesin = "Pengeringan"
                                        } else {
                                            jenis_mesin = "Reguler (Tanpa Mesin Snapbridge)"
                                        }
                                        this.snapsearch.push({
                                            nama: data[i].nama,
                                            harga: data[i].harga,
                                            idsnap: data[i].id,
                                            durasi_penyelesaian_jam: this.convertSeconds(data[i].durasi),
                                            durasi_penyelesaian_Menit: this.sisaJam(data[i].durasi),
                                            jenis: jenis_layanan,
                                            tipe: jenis_mesin,
                                            idjenis_mesin: data[i].jenis,
                                        })
                                        $('#loadingPage').hide();
                                        $('#loadingPage').removeClass('overlayLoading');
                                    }
                                } else {
                                	if (this.snapSearchPagination.offset === 0) {
		                                $("#textTopsnap").text("Tidak menemukan '" + key + "'");
		                                $('#loadingPage').hide();
		                                $('#loadingPage').removeClass('overlayLoading');
	                                }
                                }
	                            this.snapSearchPagination.pageNumber++
                                $('#loadingPage').hide();
                                $('#loadingPage').removeClass('overlayLoading');
	                            $('#loadingSpinnerSnapSearch').hide()
                            }
                        }
                    } catch (e) {
                    	this.$catch_error_response(e)
	                    $('#loadingSpinnerSnapSearch').hide()
	                    $('#loadingPage').hide();
	                    $('#loadingPage').removeClass('overlayLoading');
                    }
                } else {
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                    this.snapsearch = "";
                    $("#textTopsnap").text("Minimal 2 karakter")
                }
            },
	        filter(payload) {
		        this.snapPagination = payload.data;
		        this.listsnap()
		        setTimeout(function () {
			        $("#dropdownMenuButton-" + payload.type).html(payload.textSorting)
		        },500)
	        }
        }
    }
</script>

<style scoped>
    .image.text-alignC{
        margin-top: 185px;
    }
    .offanimation{
        animation: none;
    }
    .card-2{
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .div-impor{
        background: #f2f2f2;
        border-radius: 3px;
        padding: 11px 12px;
    }

    .line-patah {

    }

    .atribute > input {
        display: none;
    }

    .atribute img {
        cursor: pointer;
    }

    .desciption-txt-modal{
        letter-spacing: -0.02em;
        line-height: 140%;
        color: #333333;
    }

    .nomore {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    #loadingPageImportSnap {
        display: none;
	    height: 100vh;
    }

    .show-import {
        display: block !important;
    }

    .info-snap{
	    padding: 2px 4px;
	    border-radius: 3px;
    }
</style>